import RecurrenceExceptionModalLoader from './RecurrenceExceptionModalLoader';

export default RecurrenceExceptionModalLoader;
